export default "__VITE_ASSET__1cc79ef4__"